<template>
  <div class="history-row d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <span class="version-badge">v{{ item.version }}</span>
      <span class="status-badge" :class="statusClass">{{ item.status }}</span>
      <span class="history-meta ml-2">
        {{ item.referenceCurriculum || 'Sin currículo indicado' }} ·
        {{ formatDate(item.createdDate) }}
      </span>
    </div>

    <!--
      Un solo menú de "Acciones" en vez de 2-4 botones sueltos por fila (antes se veía muy
      regado). Este es el componente REAL de MiPE para esto -- paquete "dropdown" (confirmado en
      package.json), no bootstrap-vue: MiPE ya lo usa así en otras pantallas (ej.
      ResultRow.vue de materials-and-equipments), recibe las opciones como un array de objetos
      (items), no como slots/children -- cada uno con su propio "click", no eventos emitidos por
      el dropdown en sí. Sin :icon -- solo el texto "Acciones" (default del componente), sin el
      ícono de tres puntos que quedaba antes.
    -->
    <drop-down always-show-dropdown :items="actionItems" />
  </div>
</template>

<script>
import DropDown from 'dropdown';
import moment from 'moment';

export default {
  name: 'AiPromptConfigHistoryRow',
  components: { DropDown },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusClass() {
      return {
        'status-borrador': this.item.status === 'Borrador',
        'status-publicado': this.item.status === 'Publicado',
        'status-archivado': this.item.status === 'Archivado',
      };
    },
    // Contrato real de "dropdown" (node_modules/dropdown/src/dropdown.vue): recibe un array de
    // objetos {name, icon, click, ...}, no slots ni b-dropdown-item -- cada opción ejecuta su
    // propio "click" directamente, el componente no emite eventos propios.
    //
    // 25 ago 2026: para una fila en Borrador, la segunda opción ahora dice "Editar" en vez de
    // "Nueva versión desde aquí" -- sigue emitiendo el mismo evento 'create-version' (Main.vue
    // la abre igual, con el contenido de esta fila cargado en el formulario editable), pero
    // ahora SÍ describe lo que en verdad pasa al guardar: como CreateEdit.vue detecta que el
    // origen sigue en Borrador, "Guardar" actualiza esta MISMA fila en sitio (updateDraft), no
    // crea una versión nueva -- ver AIPromptConfigurationEngine.UpdateDraftAsync. Para
    // Publicado/Archivado el label real sigue siendo "Nueva versión desde aquí", porque ahí SÍ
    // se crea una fila nueva (esas deben permanecer inmutables). Astianax reportó que un
    // Borrador "ya no se podía editar" -- la función ya existía (este mismo botón), pero el
    // label no lo dejaba claro y "Ver" (la opción obvia) está bloqueada a propósito.
    actionItems() {
      const esBorrador = this.item.status === 'Borrador';

      const items = [
        {
          name: 'Ver',
          icon: 'fas fa-eye',
          click: () => this.$emit('view', this.item),
        },
        {
          name: esBorrador ? 'Editar' : 'Nueva versión desde aquí',
          icon: esBorrador ? 'fas fa-pen' : 'fas fa-code-branch',
          click: () => this.$emit('create-version', this.item),
        },
      ];

      if (esBorrador) {
        items.push(
          {
            name: 'Publicar',
            icon: 'fas fa-cloud-upload-alt text-green',
            class: 'text-green',
            click: () => this.$emit('publish', this.item),
          },
          {
            name: 'Archivar',
            icon: 'fas fa-box-archive text-danger',
            class: 'text-danger',
            click: () => this.$emit('archive', this.item),
          }
        );
      }

      return items;
    },
  },
  methods: {
    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY hh:mm A') : '';
    },
  },
};
</script>

<style scoped>
.history-row {
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  box-shadow: 0px 3px 6px #00000014;
  padding: 10px 16px;
  margin-bottom: 10px;
}

.version-badge {
  font: bold 12px/1 Lato;
  color: #11291b;
  background: #f2f2f2;
  border-radius: 20px;
  padding: 4px 10px;
  margin-right: 8px;
}

.status-badge {
  font: bold 11px/1 Lato;
  border-radius: 20px;
  padding: 4px 10px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.status-borrador {
  background: #fff4e0;
  color: #a66a00;
}

.status-publicado {
  background: #e3f6ee;
  color: #007a50;
}

.status-archivado {
  background: #eee;
  color: #6b6b6b;
}

.history-meta {
  font-size: 12.5px;
  color: #6b6b6b;
}
</style>
